import MaintainScreenSection from '../../organism/MaintainScreenSection';
import NotFoundSection from '../../organism/NotFoundSection';
import { Layout } from '../../templates';

const ErrorScreen = ({ errorCode, withLayout }: { errorCode: number; withLayout?: boolean }) => {
  let section: JSX.Element;
  switch (errorCode) {
    case 404:
      section = <NotFoundSection />;
      break;
    case 500:
      section = <MaintainScreenSection />;
      break;
    default:
      section = <NotFoundSection />;
      break;
  }

  return withLayout ? <Layout>{section}</Layout> : section;
};

export default ErrorScreen;
